import { FlowchartActionDto } from '@treetop/shared/model';

export function flattenActionsRecursive(actions: FlowchartActionDto[]): FlowchartActionDto[] {
  const result: FlowchartActionDto[] = [];
  if (!Array.isArray(actions) || actions.length == 0) {
    return result;
  }
  actions.forEach((action) => {
    if (Array.isArray(action.children) && action.children.length > 0) {
      result.push(...flattenActionsRecursive(action.children));
    }
    result.push(action);
  });
  return result;
}
